module.exports = __webpack_public_path__ + "media/images/plus-29e1b4d080fcf3480077bccbe0c700bc.svg";